import { GlobalWorkerOptions } from 'pdfjs-dist';

function resolvePdfWorkerSrc(): string {
    try {
        const loaded = (require as any)('pdfjs-dist/build/pdf.worker.min.mjs');

        if (typeof loaded === 'string' && loaded.length > 0) {
            return loaded;
        }

        if (loaded && typeof loaded === 'object') {
            const candidate = (loaded as { default?: unknown }).default;

            if (typeof candidate === 'string' && candidate.length > 0) {
                return candidate;
            }
        }
    } catch {
    }

    return '';
}

GlobalWorkerOptions.workerSrc = resolvePdfWorkerSrc();
